import { Injectable } from '@angular/core';
import { AuthenticationSamlService } from '../../core/security/authentication/authentication.saml.service';

@Injectable({
  providedIn: 'root'
})
export class CallbackSamlService {

  constructor(private authenticationSamlService: AuthenticationSamlService) { }

  callbackToken(token : string) {
    //console.log('callback-saml.service - callbackToken - token:' + token);
    return this.authenticationSamlService.callbackToken(token);
  }

}
